module.exports = __webpack_public_path__ + "static/media/download.5adf2840.svg";